import {FormikProps} from 'formik';
import {ChangeEvent, RefObject} from 'react';
import LikeInputOutlet from '../../../../components/IlikeIputOutlet';
import {ShowFormError} from '../../../../utilities/helper/showFormError';
import {IProductForm} from './productFormData';

interface IProps {
  form: FormikProps<IProductForm>;
  nameInputRef: RefObject<HTMLDivElement>;
}

const NameInput = ({form, nameInputRef}: IProps) => {
  return (
    <div ref={nameInputRef}>
      <p className="mb-2 color-gray-1 text-md">
        نام محصول <span className="text-red-500">*</span>
      </p>

      <LikeInputOutlet
        name="title"
        label=""
        value={form?.values?.name || ''}
        autoComplete="off"
        placeholder="نام محصول را وارد کنید"
        touched={!!form?.values.name}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          form?.setFieldValue('name', e.target.value);
        }}
      />

      <ShowFormError field="name" form={form} />
    </div>
  );
};

export default NameInput;
